import React, { useState } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";

import constants from "../../../../constants";
import { DEFAULT_PIC } from "../../../../constants/image";
import { getDashboardPath } from "../../../../constants";
import { getUserData,} from "../../../../utils/localStorage";
import {convertTimeTo12HourFormat} from  "../../../../utils/parseDateTime";
import "./RequestAppointment.css";

import AcceptModal from "../PopupModal/AcceptModal";
import AppointmentIcon from "../../../../components/uiElements/icons/profileIcons/AppointmentIcons";
import Button from "../../../../components/formElements/button/Button";

const RequestAppointment = ({
  appointmentData,
  onMyAppointments,
  onUpdate,
  personalInfo,
  onGuestUpdate,
}) => {
  const [isOpen, setIsOpen] = useState(undefined);

  let openModal = value => {
    setIsOpen(value);
  };
  let closeModal = () => {
    setIsOpen(undefined);
  };

  const isGuest = appointmentData?.guest_doctor_id === getUserData()?.id;
  

  return (
    <>
      <AcceptModal
        isOpen={isOpen}
        closeModal={() => {
          closeModal();
          isOpen === "accept" && onMyAppointments();
        }}
        appointmentData={appointmentData}
        onAcceptSuccess={() => onMyAppointments()}
        onUpdate={isGuest ? onGuestUpdate : onUpdate}
        personalInfo={personalInfo}
      />
      <div className=" col-xs-4 appointment position-relative ">
        <div className="mb-4">
          <Link
            to={{pathname:getDashboardPath(
              `/patients/detail/${appointmentData.patient_detail.id}`
            ),state:{pop:true}}}
            className="link"
          >
            {" "}
            <img
              src={appointmentData?.patient_detail?.image || DEFAULT_PIC}
              className="profile-image-secondary"
              alt={appointmentData?.id}
            />
            <span className="patient-name">{appointmentData.patientName}</span>
          </Link>
          <Link
            to={getDashboardPath(`/appointments/detail/${appointmentData?.id}`)}
            className="link"
          >
            <span className="float-right">
              <AppointmentIcon type="viewProfile" />
            </span>
          </Link>
        </div>

        <div className="mb-2">
          <AppointmentIcon type="clock" />
          <span>
            {convertTimeTo12HourFormat(appointmentData.startTime)}
          </span>
        </div>
        <div className="row">
          <span className="col-md-1">
            <AppointmentIcon type="bars" />
          </span>
          <span
            className={classnames(
              "col-md-10 pl-2 ",
              appointmentData.status === "RESCHEDULE_REQUEST" ? "complaint" : ""
            )}
          >
            {appointmentData.topic}
          </span>
        </div>

        {appointmentData.status === "RESCHEDULE_REQUEST" ? (
          <>
            <div>
              <p className="text-danger mt-1">Requested to Reschedule</p>
            </div>
            <div className="action-button1 ">
              <Button
                type="outline"
                label="Deny"
                className="h-50"
                style={{
                  minWidth: "308px",
                }}
                onClick={() => openModal("deny")}
              />
            </div>
          </>
        ) : (
          <div className="action-button content-center">
            <Button
              label="Accept"
              className="mr-2 h-50"
              style={{
                minWidth: isGuest ? 150 : 95,
              }}
              onClick={() => {
                isGuest
                  ? onGuestUpdate(
                      appointmentData.id,
                      constants.APPOINTMENT_STATUS.accepted,
                      () => {
                        openModal("accept");
                      }
                    )
                  : onUpdate(
                      appointmentData.id,
                      constants.APPOINTMENT_STATUS.accepted,
                      () => {
                        openModal("accept");
                      }
                    );
              }}
            />
            {!isGuest && (
              <Button
                label="Reschedule"
                className="mr-2 h-50"
                style={{
                  minWidth: 105,
                }}
                onClick={() => openModal("reschedule")}
              />
            )}
            <Button
              type="outline"
              label="Deny"
              className="h-50"
              style={{
                minWidth: isGuest ? 150 : 95,
              }}
              onClick={() => openModal("deny")}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default RequestAppointment;
